import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

export const fetchAllEmployeelog = createAsyncThunk(
    'report/fetchAllEmployeelog',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/employeelog`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all employee log');
        }
    }
);

export const fetchAllEmployeelogById = createAsyncThunk(
    'report/fetchAllEmployeelogById',
    async (Id : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/employeelog/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all employee log By Id');
        }
    }
);